export default {
  readMore: {
    id: 'product_page_grade_description_modal_more',
    defaultMessage: 'Read more',
  },
}
